var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocsDash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.53838 6.98081H7.96163V6.23081H2.53838V6.98081ZM2.53838 9.05775H7.96163V8.30775H2.53838V9.05775ZM2.53838 11.1347H5.71163V10.3847H2.53838V11.1347ZM1.21162 13.5C0.866375 13.5 0.578125 13.3844 0.346875 13.1531C0.115625 12.9219 0 12.6336 0 12.2884V1.21162C0 0.866375 0.115625 0.578125 0.346875 0.346875C0.578125 0.115625 0.866375 0 1.21162 0H7.125L10.5 3.375V12.2884C10.5 12.6336 10.3844 12.9219 10.1531 13.1531C9.92188 13.3844 9.63363 13.5 9.28838 13.5H1.21162ZM6.75 3.75V0.75H1.21162C1.09612 0.75 0.990313 0.798063 0.894188 0.894188C0.798063 0.990313 0.75 1.09612 0.75 1.21162V12.2884C0.75 12.4039 0.798063 12.5097 0.894188 12.6058C0.990313 12.7019 1.09612 12.75 1.21162 12.75H9.28838C9.40388 12.75 9.50969 12.7019 9.60581 12.6058C9.70194 12.5097 9.75 12.4039 9.75 12.2884V3.75H6.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocsDash);
export default __webpack_public_path__ + "static/media/docs_dash.23261d8bfe075b925dbe743449276b36.svg";
export { ForwardRef as ReactComponent };